


































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Settings extends Vue {
    public playerKey: string = '';

    public configs: Array<{
        playerKey: string,
        vudrmToken?: string,
        content: Array<{
            stream: string,
            label: string,
        }>,
    }> = [
        { playerKey: 'vuplay-demo-app|12150b2f-8468-4eca-bd22-5e8a1af7237f', content: [] },
    ];

    public addConfig() {
        this.configs.push({ playerKey: 'vuplay-demo-app|12150b2f-8468-4eca-bd22-5e8a1af7237f', content: [] });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Settings.vue